import React, { Component } from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import withAuth from "../../components/withAuth";

// LIBS
import API from "../../api";
import Model from "../../models/users";
import validateForm from "../../lib/helpers/validateForm";
import { getDateFormat, getDateFromDatepicker } from "../../lib/helpers/dates";

// UI
import {
  Alerts,
  Header,
  HeaderPage,
  Box,
  Row,
  Col,
  Input,
  Button,
  ButtonGroup,
  Dropdown
} from "../../ui";

class DepositorEditPage extends Component {
  state = {
    titleHeader: "Изменение залогодателя",
    depositor: {},
    form: {
      f: {
        value: "",
        isEdited: false,
        isDate: false,
        isError: false,
        errors: [],
        validate: Model.f
      },
      i: {
        value: "",
        isEdited: false,
        isDate: false,
        isError: false,
        errors: [],
        validate: Model.i
      },
      o: {
        value: "",
        isEdited: false,
        isDate: false,
        isError: false,
        errors: [],
        validate: Model.o
      },
      docs: {
        value: "",
        isEdited: false,
        isNumber: false,
        isError: false,
        errors: [],
        validate: Model.docs
      },
      docs_number: {
        value: "",
        isEdited: false,
        isNumber: true,
        isError: false,
        errors: [],
        validate: Model.docs_number
      },
      docs_give_from: {
        value: "",
        isEdited: false,
        isNumber: false,
        isError: false,
        errors: [],
        validate: Model.docs_give_from
      },
      docs_give_date: {
        value: "",
        isEdited: false,
        isDate: true,
        isError: false,
        errors: [],
        validate: Model.docs_give_date
      },
      tel: {
        value: "",
        isEdited: false,
        isDate: false,
        isError: false,
        errors: [],
        validate: Model.tel
      },
      place: {
        value: "",
        isEdited: false,
        isDate: false,
        isError: false,
        errors: [],
        validate: Model.address
      }
    },
    buttons: {
      saveDisabled: false,
      docs: {
        list: [
          {
            id: "ud",
            title: "Удостоверение личности",
            onSelect: true,
            select: true
          },
          {
            id: "passport",
            title: "Паспорт",
            onSelect: true,
            select: true
          }
        ]
      }
    }
  };

  async componentDidMount() {
    const depositorId = this.props.match.params.id;
    const depositor = await API.depositors.getOne(depositorId, { full: true });

    if (depositor && depositor._id) {
      const { form } = this.state;

      // Заполняем форму
      for (let key in form) {
        if (form[key].isNumber) {
          form[key].value = String(depositor[key] || "") || "";
        } else if (form[key].isDate) {
          let resultDate = getDateFromDatepicker(depositor[key]);
          form[key].value = depositor[key]
            ? resultDate.isCorrect
              ? getDateFormat(resultDate.date)
              : depositor[key]
            : "";
        } else {
          form[key].value = depositor[key] || "";
        }
      }

      this.setState({ depositor, form });
    }
  }

  handleInput = e => {
    let value = e.target.value;
    let name = e.target.name;
    const { form } = this.state;

    if (name && form[name]) {
      if (form[name].isNumber) {
        value = String(value || "") || "";
      }

      this.setState(prevState => {
        return {
          form: {
            ...prevState.form,
            [name]: {
              ...prevState.form[name],
              value,
              isEdited: true,
              isError: false,
              errors: []
            }
          }
        };
      });
    }
  };

  handleDatepicker = (name, value) => {
    console.log("handleDatepicker in page:", name, value);

    this.setState(prevState => {
      return {
        form: {
          ...prevState.form,
          [name]: {
            ...prevState.form[name],
            value,
            isEdited: true,
            isError: false,
            errors: []
          }
        }
      };
    });
  };

  handleSelectDropdown(item, name) {
    if (item && name) {
      let value = item.id;

      this.setState(prevState => {
        return {
          form: {
            ...prevState.form,
            [name]: {
              ...prevState.form[name],
              value,
              isEdited: true,
              isError: false,
              errors: []
            }
          }
        };
      });
    }
  }

  handleFormSubmit = async e => {
    e.preventDefault();

    const result = validateForm(this.state.form);

    this.setState({
      form: result.form
    });

    // Success
    if (result.valid) {
      // Отключаем кнопку
      this.setState(prevState => {
        return {
          buttons: { ...prevState.buttons, saveDisabled: true },
          loading: true
        };
      });

      const { form } = this.state;
      const depositorId = this.props.match.params.id;
      const optionsRequest = {};

      for (let nameItem in form) {
        if (form[nameItem].isEdited) {
          optionsRequest[nameItem] = form[nameItem].value;
        }
      }

      // Есть изменения?
      if (Object.keys(optionsRequest).length) {
        // Изменение текущего
        const resultUpdated = await API.depositors.editOne(depositorId, {
          ...optionsRequest
        });

        if (resultUpdated) {
          Alerts.success("Информация о залогодателе сохранена");

          // Включаем кнопку, данные сохранились
          this.setState(prevState => {
            return {
              buttons: { ...prevState.buttons, saveDisabled: false }
            };
          });

          this.props.history.goBack();
        } else {
          Alerts.error("Информация о залогодателе не сохранена");

          // Включаем кнопку, данные не сохранились
          this.setState(prevState => {
            return {
              buttons: { ...prevState.buttons, saveDisabled: false }
            };
          });
        }
      } else {
        Alerts.alert("В информации о залогодателе нет изменений");

        // Включаем кнопку, данные не сохранились
        this.setState(prevState => {
          return {
            buttons: { ...prevState.buttons, saveDisabled: false }
          };
        });

        this.props.history.goBack();
      }
    }
  };

  render() {
    const { depositor } = this.state;

    return (
      <div className="short">
        <Helmet>
          <title>{this.state.titleHeader}</title>
        </Helmet>

        <form className="form" onSubmit={this.handleFormSubmit}>
          <HeaderPage
            title={this.state.titleHeader}
            back={this.props.history.goBack}
          >
            <ButtonGroup>
              <Button
                type="submit"
                theme="success"
                disabled={this.state.buttons.saveDisabled}
              >
                Сохранить информацию
              </Button>
              <Button
                type="button"
                onClick={() => this.props.history.goBack()}
                theme="default"
              >
                Отмена
              </Button>
            </ButtonGroup>
          </HeaderPage>

          <Box>
            <Header size={2} margin="no-top">
              {depositor.ud_number}
            </Header>

            <Row>
              <Col padding="no-top-left">
                <Header size={5} margin="no-top">
                  Главное
                </Header>

                <Input
                  label="Фамилия:"
                  name="f"
                  value={this.state.form.f.value}
                  errors={this.state.form.f.errors}
                  handleChange={this.handleInput}
                />

                <Input
                  label="Имя:"
                  name="i"
                  value={this.state.form.i.value}
                  errors={this.state.form.i.errors}
                  handleChange={this.handleInput}
                />

                <Input
                  label="Имя:"
                  name="o"
                  value={this.state.form.o.value}
                  errors={this.state.form.o.errors}
                  handleChange={this.handleInput}
                />
              </Col>

              <Col padding="no-top-left">
                <Header size={5} margin="no-top">
                  Документ
                </Header>

                <Dropdown
                  label="Вид документа:"
                  name="docs"
                  block={true}
                  required={true}
                  type="select"
                  title="Выберите тип документа"
                  errors={this.state.form.docs.errors}
                  list={this.state.buttons.docs.list}
                  selectedId={this.state.form.docs.value}
                  onSelect={item => {
                    this.handleSelectDropdown(item, "docs");
                  }}
                />

                <Input
                  label="Номер документа:"
                  name="docs_number"
                  // type="integer"
                  value={this.state.form.docs_number.value}
                  errors={this.state.form.docs_number.errors}
                  handleChange={this.handleInput}
                />

                <Input
                  label="Кем выдан:"
                  name="docs_give_from"
                  value={this.state.form.docs_give_from.value}
                  errors={this.state.form.docs_give_from.errors}
                  handleChange={this.handleInput}
                />

                <Input
                  label="Дата выдачи:"
                  name="docs_give_date"
                  type="date"
                  dateTop={true}
                  value={this.state.form.docs_give_date.value}
                  errors={this.state.form.docs_give_date.errors}
                  handleChange={this.handleInput}
                  handleChangeDate={this.handleDatepicker}
                />
              </Col>

              <Col padding="no-top-left">
                <Header size={5} margin="no-top">
                  Прочее
                </Header>

                <Input
                  label="Телефон:"
                  name="tel"
                  value={this.state.form.tel.value}
                  errors={this.state.form.tel.errors}
                  handleChange={this.handleInput}
                />

                <Input
                  label="Адрес:"
                  name="place"
                  value={this.state.form.place.value}
                  errors={this.state.form.place.errors}
                  handleChange={this.handleInput}
                />
              </Col>
            </Row>
          </Box>
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => ({});

export default connect(mapStateToProps)(withAuth(DepositorEditPage));
